import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { Navigate, Outlet } from "react-router-dom";

export const messagingRoutes: PermissionedRouteObject[] = [
  {
    element: <Outlet />,
    children: [
      { index: true, element: <Navigate replace to="pre-purchase" /> },
      {
        path: "conversations",
        async lazy() {
          const { MessagingConversationsPage } = await import(
            "../../../messaging/conversations-page"
          );
          return { Component: MessagingConversationsPage };
        },
      },
      {
        path: "pre-purchase",
        async lazy() {
          const { PrePurchaseConfigPage } = await import(
            "../../../messaging/pre-purchase-config-page"
          );
          return { Component: PrePurchaseConfigPage };
        },
      },
      {
        path: "post-purchase",
        async lazy() {
          const { PostPurchaseConfigPage } = await import(
            "../../../messaging/post-purchase-config-page"
          );
          return { Component: PostPurchaseConfigPage };
        },
      },
    ],
  },
];
